export default "__VITE_ASSET__Bc06Td03__"